import { render, staticRenderFns } from "./AmpliacionesReduccionesExportView.vue?vue&type=template&id=04dd23fe&"
import script from "./AmpliacionesReduccionesExportView.vue?vue&type=script&lang=js&"
export * from "./AmpliacionesReduccionesExportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports